import { render, staticRenderFns } from "./jobInformation5.vue?vue&type=template&id=383dd2b8&scoped=true"
import script from "./jobInformation5.vue?vue&type=script&lang=js"
export * from "./jobInformation5.vue?vue&type=script&lang=js"
import style0 from "./jobInformation5.vue?vue&type=style&index=0&id=383dd2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383dd2b8",
  null
  
)

export default component.exports